import React, { useState } from "react";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Chatbot from "./components/Chatbot/Chatbot";
import DailyNotification from "./components/DailyNotification/DailyNotification";
import { Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/Login/Login";

import Sinksar from "./pages/Sinksar/Sinksar";
import BahireHasab from "./pages/BahireHasab/BahireHasab";
import Gitsawe from "./pages/Gitsawe/Gitsawe";
import Bible from "./pages/Bible/Bible";
import WudasieMariam from "./pages/WudasieMariam/WudasieMariam";
import Seatat from "./pages/Seatat/Seatat";
import Home from "./pages/Home/Home";
import Hibuat from "./pages/Hibuat/Hibuat";
import Books from "./pages/Books/Books";
import Mahlet from "./pages/Mahlet/Mahlet";
import Filseta from "./pages/Filseta/Filseta";
import News from "./pages/News/News";
import Posting from "./pages/Posting/Posting";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService/TermsOfService";
import Support from "./pages/Support/Support";
import PaymentSuccess from "./pages/PaymentSuccess/PaymentSuccess";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import Bookmarks from "./pages/Bookmarks/Bookmarks";
import NotesManager from "./pages/NotesManager/NotesManager";
import Projects from "./pages/Projects/Projects";

// Pages where sidebar should be hidden (fullscreen standalone flows)
const NO_SIDEBAR = ['/login', '/payment-success'];

const AppInner = () => {
  const location = useLocation();
  const hideSidebar = NO_SIDEBAR.includes(location.pathname);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarVisible, setSidebarVisible] = useState(true);

  return (
    <div className="app">
      <ScrollToTop />
      <Header />
      <Navbar
        onToggleSidebar={() => {
          if (window.innerWidth >= 1024) {
            setSidebarVisible(v => !v);
          } else {
            setSidebarOpen(o => !o);
          }
        }}
        sidebarVisible={sidebarVisible}
      />

      <div className="app-body">
        {/* Desktop sidebar */}
        {!hideSidebar && sidebarVisible && <Sidebar />}

        {/* Mobile overlay */}
        {sidebarOpen && (
          <div className="fixed inset-0 bg-black/50 z-40" onClick={() => setSidebarOpen(false)} />
        )}

        {/* Mobile drawer */}
        <div className={`fixed top-0 left-0 h-full z-50 transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <Sidebar />
        </div>

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sinksar" element={<Sinksar />} />
            <Route path="/bahirehasab" element={<BahireHasab />} />
            <Route path="/gitsawie" element={<Gitsawe />} />
            <Route path="/bible" element={<Bible />} />
            <Route path="/wudasie" element={<WudasieMariam />} />
            <Route path="/seatat" element={<Seatat />} />
            <Route path="/hibuat" element={<Hibuat />} />
            <Route path="/books" element={<Books />} />
            <Route path="/mahlet" element={<Mahlet />} />
            <Route path="/filseta" element={<Filseta />} />
            <Route path="/news" element={<News />} />
            <Route path="/posting" element={<Posting />} />
            <Route path="/postings" element={<Posting />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/support" element={<Support />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/bookmarks" element={<Bookmarks />} />
            <Route path="/bookmark" element={<Bookmarks />} />
            <Route path="/notes" element={<NotesManager />} />
            <Route path="/note" element={<NotesManager />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
      </div>

      <Footer />
      <Chatbot />
      <DailyNotification />
    </div>
  );
};

const App = () => (
  <AuthProvider>
    <LanguageProvider>
      <AppInner />
    </LanguageProvider>
  </AuthProvider>
);

export default App;
